(function() {
  'use strict';

  var API_BASE = 'https://fitment-api.oempartsdepartment.com';
  var SECTION_ID = 'oem-image-lookup';
  var STORAGE_KEY = 'oem_garage_vehicle';
  var FITMENT_KEY = 'oem_fitment_vehicle';
  var CACHE_KEY = 'oem_categories_cache';
  var CACHE_TTL = 30 * 60 * 1000;
  var CONCURRENCY = 6;
  var productCache = {};

  function getVehicle() {
    try {
      var v = localStorage.getItem(STORAGE_KEY);
      if (v) return JSON.parse(v);
      var f = localStorage.getItem(FITMENT_KEY);
      if (f) return JSON.parse(f);
    } catch (e) {}
    return null;
  }

  function getCacheKey(vehicle) {
    return [vehicle.year, vehicle.make, vehicle.model, vehicle.sub_model || ''].join('|');
  }

  function getCachedCategories(vehicle) {
    try {
      var raw = localStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var cached = JSON.parse(raw);
      if (cached.key !== getCacheKey(vehicle)) return null;
      if (Date.now() - cached.ts > CACHE_TTL) return null;
      return cached.data;
    } catch (e) {}
    return null;
  }

  function setCachedCategories(vehicle, data) {
    try {
      localStorage.setItem(CACHE_KEY, JSON.stringify({
        key: getCacheKey(vehicle),
        ts: Date.now(),
        data: data
      }));
    } catch (e) {}
  }

  function fetchCategories(vehicle) {
    var url = API_BASE + '/fitment/categories?year=' + encodeURIComponent(vehicle.year) +
      '&make=' + encodeURIComponent(vehicle.make) +
      '&model=' + encodeURIComponent(vehicle.model);
    if (vehicle.sub_model) url += '&sub_model=' + encodeURIComponent(vehicle.sub_model);
    return fetch(url).then(function(r) { return r.json(); });
  }

  function buildSkuData(data) {
    var skus = new Set();
    var meta = {};
    var make = data.make || '';

    if (!data || !data.categories) return { skus: skus, meta: meta };

    data.categories.forEach(function(cat) {
      if (cat.subcategories) {
        cat.subcategories.forEach(function(sub) {
          if (sub.skus) sub.skus.forEach(function(s) {
            var upper = s.toUpperCase();
            skus.add(upper);
            meta[upper] = { title: sub.name + ' - ' + make + ' (' + s + ')', image: null };
          });
        });
      }
    });

    if (data.products) {
      Object.keys(data.products).forEach(function(sku) {
        var p = data.products[sku];
        var upper = sku.toUpperCase();
        if (p && p.title) {
          meta[upper] = { title: p.title, image: p.image || null };
        } else if (p && p.image && meta[upper]) {
          meta[upper].image = p.image;
        }
      });
    }

    return { skus: skus, meta: meta };
  }

  function extractSku(link) {
    var infoDiv = link.querySelector('.oem-parts__product-info');
    if (!infoDiv) return null;
    var nodes = infoDiv.querySelectorAll('div, span, p');
    for (var i = 0; i < nodes.length; i++) {
      var text = nodes[i].textContent || '';
      var match = text.match(/Part\s*#:\s*(.+)/i);
      if (match) return match[1].trim().toUpperCase();
    }
    var allText = infoDiv.textContent || '';
    var m = allText.match(/Part\s*#:\s*(\S+)/i);
    return m ? m[1].trim().toUpperCase() : null;
  }

  function fetchProductMeta(handle) {
    if (productCache[handle] !== undefined) return Promise.resolve(productCache[handle]);
    return fetch('/products/' + handle + '.json')
      .then(function(r) {
        if (!r.ok) throw new Error(r.status);
        return r.json();
      })
      .then(function(data) {
        var p = data.product;
        if (!p) { productCache[handle] = null; return null; }
        var v = p.variants && p.variants[0];
        var images = p.images || [];
        var meta = {
          title: p.title || null,
          image: images.length ? images[0].src : null,
          price: v ? v.price : null,
          compare_at_price: v ? v.compare_at_price : null
        };
        productCache[handle] = meta;
        return meta;
      })
      .catch(function() {
        productCache[handle] = null;
        return null;
      });
  }

  function applyTitle(link, title) {
    var infoDiv = link.querySelector('.oem-parts__product-info');
    if (!infoDiv || !title) return;
    var titleEl = infoDiv.querySelector('.oem-parts__product-title') || infoDiv.querySelector('div:first-child');
    if (titleEl) titleEl.textContent = title;
  }

  function applyPrice(link, price, compareAt) {
    if (!price) return;
    var infoDiv = link.querySelector('.oem-parts__product-info');
    if (!infoDiv) return;
    var priceEl = infoDiv.querySelector('.oem-parts__product-price');
    if (!priceEl) {
      priceEl = document.createElement('div');
      priceEl.className = 'oem-parts__product-price';
      infoDiv.appendChild(priceEl);
    }
    var priceNum = parseFloat(price);
    if (isNaN(priceNum)) return;
    var html = '';
    if (compareAt && parseFloat(compareAt) > priceNum) {
      html = '<span style="text-decoration:line-through;color:#999;margin-right:6px;">$' + parseFloat(compareAt).toFixed(2) + '</span>' +
        '<span style="color:#c62828;font-weight:700;">$' + priceNum.toFixed(2) + '</span>';
    } else {
      html = '<span style="font-weight:700;">$' + priceNum.toFixed(2) + '</span>';
    }
    priceEl.innerHTML = html;
    priceEl.style.cssText = 'margin-top:4px;font-size:0.95rem;';
  }

  function applyImage(link, url, alt) {
    if (!url) return;
    var imgDiv = link.querySelector('.oem-parts__product-img');
    if (!imgDiv) return;
    imgDiv.textContent = '';
    var img = document.createElement('img');
    img.src = url;
    img.alt = alt || '';
    img.loading = 'lazy';
    img.style.cssText = 'width:100%;height:100%;object-fit:contain;';
    imgDiv.appendChild(img);
  }

  function patchProduct(link, skuMeta) {
    if (link.dataset.oemEnhanced) return Promise.resolve();
    link.dataset.oemEnhanced = '1';

    var sku = extractSku(link);
    var apiMeta = sku ? skuMeta[sku] : null;
    var href = link.getAttribute('href') || '';
    var handle = href.replace('/products/', '').split('?')[0].split('#')[0];

    if (apiMeta && apiMeta.title) applyTitle(link, apiMeta.title);
    if (apiMeta && apiMeta.image) {
      applyImage(link, apiMeta.image, apiMeta.title || '');
    }

    if (!handle) return Promise.resolve();

    return fetchProductMeta(handle).then(function(shopifyMeta) {
      if (!shopifyMeta) return;
      if (shopifyMeta.title) applyTitle(link, shopifyMeta.title);
      if (shopifyMeta.image && !(apiMeta && apiMeta.image)) {
        applyImage(link, shopifyMeta.image, shopifyMeta.title || (apiMeta && apiMeta.title) || '');
      }
      applyPrice(link, shopifyMeta.price, shopifyMeta.compare_at_price);
    });
  }

  function filterAndPatchProducts(validSkus, skuMeta) {
    var links = document.querySelectorAll('a.oem-parts__product[href*="/products/"]');
    if (!links.length) return;

    var patchQueue = [];

    links.forEach(function(link) {
      var sku = extractSku(link);
      var row = link.closest('.oem-parts__product-grid') || link.parentElement;
      if (!sku || !validSkus.has(sku)) {
        link.style.display = 'none';
        if (row && row.children.length === 1) row.style.display = 'none';
      } else {
        link.style.display = '';
        if (row) row.style.display = '';
        patchQueue.push(link);
      }
    });

    var active = 0;
    function next() {
      if (!patchQueue.length && !active) return;
      while (active < CONCURRENCY && patchQueue.length) {
        active++;
        patchProduct(patchQueue.shift(), skuMeta).then(function() { active--; next(); });
      }
    }
    next();
  }

  var validSkus = null;
  var skuMeta = {};
  var initialized = false;

  function run() {
    var vehicle = getVehicle();
    if (!vehicle || !vehicle.year || !vehicle.make || !vehicle.model) return;

    var cached = getCachedCategories(vehicle);
    if (cached) {
      var result = buildSkuData(cached);
      validSkus = result.skus;
      skuMeta = result.meta;
      filterAndPatchProducts(validSkus, skuMeta);
      return;
    }

    fetchCategories(vehicle).then(function(data) {
      setCachedCategories(vehicle, data);
      var result = buildSkuData(data);
      validSkus = result.skus;
      skuMeta = result.meta;
      filterAndPatchProducts(validSkus, skuMeta);
    }).catch(function(e) {
      console.error('OEM parts filter error:', e);
    });
  }

  var debounceTimer = null;
  var observer = new MutationObserver(function() {
    if (!validSkus) return;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function() {
      filterAndPatchProducts(validSkus, skuMeta);
    }, 200);
  });

  function init() {
    if (initialized) return;
    initialized = true;
    run();

    var target = document.querySelector('.oem-parts__content') ||
                 document.querySelector('.oem-parts__layout') ||
                 document.body;
    observer.observe(target, { childList: true, subtree: true });

    window.addEventListener('oemVehicleSelected', function() {
      validSkus = null;
      skuMeta = {};
      productCache = {};
      localStorage.removeItem(CACHE_KEY);
      run();
    });

    window.addEventListener('oemVehicleCleared', function() {
      validSkus = null;
      skuMeta = {};
      localStorage.removeItem(CACHE_KEY);
      var links = document.querySelectorAll('a.oem-parts__product[href*="/products/"]');
      links.forEach(function(link) {
        link.style.display = '';
        var row = link.closest('.oem-parts__product-grid') || link.parentElement;
        if (row) row.style.display = '';
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
